// extracted by mini-css-extract-plugin
export default {"form_wrap":"EditVideo_form_wrap__WRwNy","video_thumb":"EditVideo_video_thumb__Unrgd","radio":"EditVideo_radio__BeytM"};